import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import { AuthQuery, Oauth2ClientConfigVo } from './types';
/* *
 * 认证 授权
 * */

export const oauth2Auth = (params: AuthQuery): AxiosPromise<string | null> =>
  request({
    url: '/member/oauth2/v1/auth',
    method: 'get',
    params
  });
/* *
 * 获取客户端配置
 * */

export const oauth2Config = (params: { clientId: string }): AxiosPromise<Oauth2ClientConfigVo> =>
  request({
    url: '/member/oauth2/v1/config',
    method: 'get',
    params
  });
